/* eslint-disable react/jsx-filename-extension */
import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import { ToastContext } from '../../contexts/toast-context-with-provider';
import CopyIcon from '../../../public/assets/deep-link.svg';
import { useUser } from '../../contexts/ssr-user-context';

export default function CopyDeeplink({ link, className }) {
  const { showToast } = useContext(ToastContext);
  const { user } = useUser();

  const handleCopy = useCallback(async () => {
    if (!link) return;
    try {
      await navigator.clipboard.writeText(link);
      showToast('Deeplink copied.');
    } catch {
      showToast('Failed to copy deeplink.');
    }
  }, [link, showToast]);

  const allowedDomains = ['@nextias.com', '@madeeasy.in'];
  const isAllowedEmail = user?.email && allowedDomains.some((d) => user.email.toLowerCase().endsWith(d));

  if (!link || !isAllowedEmail) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleCopy}
      className={`fixed -translate-x-1/2 z-[99998] flex flex-col items-center font-semibold hover:cursor-pointer hover:underline gap-1 text-xs px-2 py-1 ${className || 'bottom-4 left-8'}`}
      aria-label="Copy deeplink"
    >
      <Image src={CopyIcon} alt="copy" width={58} height={58} />
      <span>Deeplink</span>
    </button>
  );
}

CopyDeeplink.propTypes = {
  link: PropTypes.string,
  className: PropTypes.string,
};

CopyDeeplink.defaultProps = {
  link: '',
  className: '',
};
